export const LINE_ANIMATION_MILLISECONDS = 500;
